import { CurrencyCode } from 'further-types/lp/vehicle';
import InvestorTable from './InvestorTable';
import TotalsTable from './TotalsTable';
import { Row } from 'components/Layout';
import api from 'lib/trpcClient';
import { useLayoutContext } from 'contexts/LayoutContext';
import { CircularProgress } from '@mui/material';

type Props = {
  currency: CurrencyCode;
  investorAllocations?: Array<{
    commitmentId: string;
    investorName: string;
    receivedConsideration: number;
    escrowConsideration: number;
    earnoutConsideration: number;
    withholdingTaxPayable: number;
    allocationPercentage: number;
  }>;
};

const PerInvestorAllocationTable: React.FC<Props> = ({
  currency,
  investorAllocations,
}) => {
  const { selectedVehicleId } = useLayoutContext();

  const investorAllocationsData = investorAllocations ?? [];

  const investorAllocationsTotalsQuery =
    api.lpRealisation.getInvestorAllocationsTotals.useQuery({
      vehicleId: selectedVehicleId ?? '',
      investorAllocations: investorAllocationsData,
    });

  if (investorAllocationsTotalsQuery.isLoading) {
    return <CircularProgress />;
  }

  return (
    <Row>
      <InvestorTable
        investorAllocationsTotals={investorAllocationsTotalsQuery.data ?? []}
        currency={currency}
      />
      <TotalsTable
        investorAllocationsTotals={investorAllocationsTotalsQuery.data ?? []}
        currency={currency}
      />
    </Row>
  );
};

export default PerInvestorAllocationTable;
